module.exports = __webpack_public_path__ + "img/icon-preview-notification.503f198b.svg";